// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__170GF","consentsList":"PatientConsents_consentsList__2Md5K","consentsListEmpty":"PatientConsents_consentsListEmpty___onwD"};